import React from 'react'
export default function DashCard({title="Card Name",desc="Tool description", Icon=<></> , onClickHandler=()=>{alert("pass click handler!")}, active=false }) {
    return (
        <div className="p-4 w-full md:w-1/2 lg:w-1/4 ">
            <button onClick={onClickHandler} className={`w-full h-full flex flex-col gap-4 items-center border-2 border-gray-200 px-4 py-6 rounded-lg ${active?"bg-sky-100":""} hover:bg-sky-100`}>
                {Icon}
                <h2 className="title-font font-medium text-3xl text-gray-900">{title}</h2>
                <p className="leading-relaxed">{desc}</p>
            </button>
        </div>
    )
}
